
import UMUM from "../../library/umum.js";
export default {
   data() {
      return {
         UMUM: UMUM,
         isPwd: true,
         isPwd2: true,
         btn_password: false,

         form: {
            id: null,
            users_id: null,
            nama_lengkap: '',
            nik: '',
            tanggal_lahir: '',
            jenis_kelamin: '',
            kabupaten_id: null,
            kecamatan_id: null,
            des_kel_id: null,
            alamat: '',
            email: '',
            no_hp: '',
            foto_profil: null,
            foto_profil_url: '',
         },
         kabupatenOptions: [],
         kecamatanOptions: [],
         deskelOptions: [],

         mdl_add: false,
         mdl_edit: false,
         mdl_hapus: false,
         btn_add: false,
         btn_edit: false,
         btn_hapus: false,

         list_data: [],
         jml_data: 0,
         total_data: 0,
         page_first: 1,
         page_last: 0,
         page_limit: 10,
         cari_value: '',

         mdl_password: false,
         dataku: {
            username: '',
            password: '',
            confirmPassword: ''
         },
         errorMessage: '',
         mdl_lihat: false,
         lihatData: {
            nama_lengkap: '',
            tanggal_lahir: '',
            jenis_kelamin: '',
            nik: '',
            email: '',
            no_hp: '',
            alamat: '',
            nama_kabupaten: '',
            nama_kecamatan: '',
            nama_des_kel: '',
            foto_profil: '',
            username: '',
            users_id: '',
            id: '',
         },
      }
   },
   computed: {
      file_path() {
         return this.$store.state.url.URL_APP + "uploads/";
      }
   },
   watch: {
      'form.kabupaten_id'(newVal) {
         this.form.kecamatan_id = null;
         this.form.des_kel_id = null;
         this.kecamatanOptions = [];
         this.deskelOptions = [];
         if (newVal) {
            this.loadKecamatan(newVal);
         }
      },
      'form.kecamatan_id'(newVal) {
         this.form.des_kel_id = null;
         this.deskelOptions = [];
         if (newVal) {
            this.loadDeskel(newVal);
         }
      }
   },
   methods: {
      loadKabupaten() {
         fetch(this.$store.state.url.REGIS_MASYARAKAT + "kabupaten")
            .then(res => res.json())
            .then(res => {
               if (res.success) {
                  this.kabupatenOptions = res.data.map(item => ({
                     label: item.label,
                     value: item.id
                  }));
               } else {
                  this.$q.notify({ type: 'negative', message: 'Gagal memuat data kabupaten' });
               }
            })
            .catch(() => {
               this.$q.notify({ type: 'negative', message: 'Terjadi kesalahan saat memuat kabupaten' });
            });
      },
      loadKecamatan(kabupatenId) {
         fetch(`${this.$store.state.url.REGIS_MASYARAKAT}kecamatan?kabupaten_id=${kabupatenId}`)
            .then(res => res.json())
            .then(res => {
               if (res.success) {
                  this.kecamatanOptions = res.data.map(item => ({
                     label: item.label,
                     value: item.id
                  }));
               } else {
                  this.$q.notify({ type: 'negative', message: 'Gagal memuat data kecamatan' });
               }
            })
            .catch(() => {
               this.$q.notify({ type: 'negative', message: 'Terjadi kesalahan saat memuat kecamatan' });
            });
      },
      loadDeskel(kecamatanId) {
         fetch(`${this.$store.state.url.REGIS_MASYARAKAT}deskel?kecamatan_id=${kecamatanId}`)
            .then(res => res.json())
            .then(res => {
               if (res.success) {
                  this.deskelOptions = res.data.map(item => ({
                     label: item.label,
                     value: item.id
                  }));
               } else {
                  this.$q.notify({ type: 'negative', message: 'Gagal memuat data desa/kelurahan' });
               }
            })
            .catch(() => {
               this.$q.notify({ type: 'negative', message: 'Terjadi kesalahan saat memuat desa/kelurahan' });
            });
      },

      getView() {
         const body = {
            page_limit: this.page_limit,
            data_ke: (this.page_first - 1) * this.page_limit,
            cari_value: this.cari_value,
         };

         fetch(this.$store.state.url.REGIS_MASYARAKAT + "getview", {
            method: "POST",
            headers: {
               "content-type": "application/json",
               authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify(body)
         })
            .then(res => res.json())
            .then(res_data => {
               if (res_data.success) {
                  this.list_data = res_data.data;
                  this.jml_data = res_data.jml_data;
                  this.total_data = res_data.total_data;
                  this.page_last = Math.ceil(this.total_data / this.page_limit);
               } else {
                  this.$q.notify({ type: "negative", message: res_data.message || "Gagal mengambil data" });
               }
            })
            .catch(err => {
               console.error("Error fetching data:", err);
               this.$q.notify({ type: "negative", message: "Gagal mengambil data masyarakat" });
            });
      },

      async addData() {
         try {
            if (this.dataku.password !== this.dataku.confirmPassword) {
               this.$q.notify({
                  type: 'negative',
                  message: 'Password dan konfirmasi password tidak sama!'
               });
               return;
            }
            if (this.dataku.password.length < 6) {
               this.$q.notify({
                  type: 'negative',
                  message: 'Password minimal 6 karakter!'
               });
               return;
            }
            if (!this.dataku.username) {
               this.$q.notify({
                  type: 'negative',
                  message: 'Username wajib diisi!'
               });
               return;
            }
            if (!this.form.nama_lengkap || !this.form.tanggal_lahir || !this.form.jenis_kelamin || !this.form.no_hp) {
               this.$q.notify({
                  type: 'negative',
                  message: 'Field wajib (Nama, Tanggal Lahir, Jenis Kelamin, No HP) harus diisi!'
               });
               return;
            }

            this.btn_add = true;

            const formData = new FormData();
            formData.append('nama_lengkap', this.form.nama_lengkap);
            formData.append('nik', this.form.nik || '');
            formData.append('tanggal_lahir', this.form.tanggal_lahir);
            formData.append('jenis_kelamin', this.form.jenis_kelamin);
            formData.append('kabupaten_id', this.form.kabupaten_id || '');
            formData.append('kecamatan_id', this.form.kecamatan_id || '');
            formData.append('des_kel_id', this.form.des_kel_id || '');
            formData.append('alamat', this.form.alamat || '');
            formData.append('email', this.form.email || '');
            formData.append('no_hp', this.form.no_hp);

            formData.append('username', this.dataku.username);
            formData.append('password', this.dataku.password);

            // Append file
            if (this.form.foto_profil && this.form.foto_profil instanceof File) {
               formData.append('foto_profil', this.form.foto_profil);
            }

            const response = await fetch(this.$store.state.url.REGIS_MASYARAKAT + "addData", {
               method: 'POST',
               headers: {
                  authorization: "kikensbatara " + localStorage.token
               },
               body: formData
            });

            const result = await response.json();

            if (response.ok && result.success) {
               this.$q.notify({
                  type: 'positive',
                  message: result.message || 'Data masyarakat berhasil ditambahkan!'
               });

               this.resetForm();
               this.mdl_add = false;
               this.getView();
            } else {
               throw new Error(result.message || 'Terjadi kesalahan saat menambah data');
            }
         } catch (error) {
            console.error('Error adding data:', error);
            this.$q.notify({
               type: 'negative',
               message: error.message || 'Gagal menambah data masyarakat!'
            });
         } finally {
            this.btn_add = false;
         }
      },

      editModal(data) {
         this.form = {
            id: data.id,
            users_id: data.users_id || null,
            nama_lengkap: data.nama_lengkap || '',
            nik: data.nik || '',
            tanggal_lahir: data.tanggal_lahir || '',
            jenis_kelamin: data.jenis_kelamin || '',
            email: data.email || '',
            no_hp: data.no_hp || '',
            kabupaten_id: data.kabupaten_id || null,
            kecamatan_id: data.kecamatan_id || null,
            des_kel_id: data.des_kel_id || null,
            alamat: data.alamat || '',
            foto_profil: null,
            foto_profil_url: data.foto_profil ? (this.file_path + data.foto_profil) : '',
         };

         this.dataku.username = data.username || '';

         if (this.form.kabupaten_id) {
            this.loadKecamatan(this.form.kabupaten_id);
            if (this.form.kecamatan_id) {
               this.loadDeskel(this.form.kecamatan_id);
            }
         }

         this.dataku.password = '';
         this.dataku.confirmPassword = '';

         this.mdl_edit = true;
      },

      async updateData() {
         this.btn_edit = true;
         try {
            if (!this.form.nama_lengkap || !this.form.tanggal_lahir || !this.form.jenis_kelamin || !this.form.no_hp) {
               throw new Error('Field wajib (Nama, TTL, Jenis Kelamin, No HP) harus diisi!');
            }
            if (this.dataku.username && this.dataku.username.length < 6) {
               throw new Error('Username minimal 6 karakter jika diubah!');
            }
            if (this.form.nik && this.form.nik.length < 16) {
               throw new Error('NIK harus berjumlah 16 angka!');
            }
            const normalizedTanggalLahir = this.normalizeDate(this.form.tanggal_lahir);
            const payload = {
               id: this.form.id,
               users_id: this.form.users_id,
               nama_lengkap: this.form.nama_lengkap,
               nik: this.form.nik || '',
               tanggal_lahir: normalizedTanggalLahir,
               jenis_kelamin: this.form.jenis_kelamin,
               email: this.form.email || '',
               no_hp: this.form.no_hp,
               kabupaten_id: this.form.kabupaten_id || null,
               kecamatan_id: this.form.kecamatan_id || null,
               des_kel_id: this.form.des_kel_id || null,
               alamat: this.form.alamat || '',
               username: this.dataku.username || '',
            };

            const hasNewFile = (this.form.foto_profil && this.form.foto_profil instanceof File);

            let response, result;

            if (hasNewFile) {
               const formData = new FormData();
               for (const key in payload) {
                  formData.append(key, payload[key] || '');
               }
               // Append files jika ada
               if (this.form.foto_profil && this.form.foto_profil instanceof File) {
                  formData.append('foto_profil', this.form.foto_profil);
               }

               response = await fetch(this.$store.state.url.REGIS_MASYARAKAT + "editData", {
                  method: "POST",
                  headers: {
                     authorization: "kikensbatara " + localStorage.token
                  },
                  body: formData
               });
               result = await response.json();
            } else {
               response = await fetch(this.$store.state.url.REGIS_MASYARAKAT + "editData", {
                  method: "POST",
                  headers: {
                     "Content-Type": "application/json",
                     authorization: "kikensbatara " + localStorage.token
                  },
                  body: JSON.stringify(payload)
               });
               result = await response.json();
            }

            if (response.ok && result.success) {
               this.$q.notify({
                  type: "positive",
                  message: result.message || "Data masyarakat berhasil diupdate"
               });

               this.mdl_edit = false;
               this.getView();
               this.resetForm();
            } else {
               throw new Error(result.message || "Gagal mengupdate data masyarakat");
            }
         } catch (error) {
            console.error("Error update data masyarakat:", error);
            this.$q.notify({
               type: "negative",
               message: error.message || "Terjadi kesalahan saat update data masyarakat"
            });
         } finally {
            this.btn_edit = false;
         }
      },

      resetForm() {
         this.form = {
            id: null,
            users_id: null,
            nama_lengkap: '',
            nik: '',
            tanggal_lahir: '',
            jenis_kelamin: '',
            kabupaten_id: null,
            kecamatan_id: null,
            des_kel_id: null,
            alamat: '',
            email: '',
            no_hp: '',
            foto_profil: null,
            foto_profil_url: '',
         };
         this.dataku = {
            username: '',
            password: '',
            confirmPassword: ''
         };
         this.kecamatanOptions = [];
         this.deskelOptions = [];
         this.errorMessage = '';
      },

      async hapusData() {
         // Validasi ID wajib
         if (!this.form.id || !this.form.users_id) {
            this.$q.notify({
               type: 'negative',
               message: 'Data tidak valid. Silakan pilih ulang.'
            });
            this.resetHapusForm();
            return;
         }

         this.btn_hapus = true;
         try {
            const payload = {
               id: this.form.id,
               users_id: this.form.users_id
            };

            const response = await fetch(this.$store.state.url.REGIS_MASYARAKAT + "removeMasyarakat", {
               method: "POST",
               headers: {
                  "Content-Type": "application/json",
                  authorization: "kikensbatara " + localStorage.token
               },
               body: JSON.stringify(payload)
            });

            const res_data = await response.json();

            if (response.ok && res_data.success) {
               this.$q.notify({
                  type: 'positive',
                  message: res_data.message || 'Data masyarakat berhasil dihapus'
               });
               this.mdl_hapus = false;
               this.getView();
               this.resetForm();
            } else {
               throw new Error(res_data.message || 'Gagal menghapus data');
            }
         } catch (error) {
            console.error('Error hapus data:', error);
            this.$q.notify({
               type: 'negative',
               message: error.message || 'Terjadi kesalahan saat menghapus data'
            });
         } finally {
            this.btn_hapus = false;
         }
      },

      async editDataPassword() {
         this.errorMessage = '';

         if (!this.dataku.password || !this.dataku.confirmPassword) {
            this.errorMessage = "Password dan Confirm Password wajib diisi!";
            return;
         }

         if (this.dataku.password.length < 6) {
            this.errorMessage = "Password minimal 6 karakter!";
            return;
         }

         if (this.dataku.password !== this.dataku.confirmPassword) {
            this.errorMessage = "Password dan Confirm Password tidak sama!";
            return;
         }

         try {
            const res = await fetch(this.$store.state.url.REGIS_MASYARAKAT + "editPasswordMasyarakat", {
               method: "POST",
               headers: {
                  "Content-Type": "application/json",
                  authorization: "kikensbatara " + localStorage.token
               },
               body: JSON.stringify({
                  users_id: this.dataku.users_id,
                  password: this.dataku.password
               })
            });

            const data = await res.json();

            if (res.ok && data.success) {
               this.$q.notify({ type: "positive", message: data.message || "Password berhasil diubah!" });
               this.mdl_password = false;
               this.dataku.password = '';
               this.dataku.confirmPassword = '';
            } else {
               this.errorMessage = data.message || "Gagal mengubah password!";
            }
         } catch (error) {
            console.error(error);
            this.errorMessage = "Terjadi kesalahan saat mengubah password.";
         }
      },

      selectData(data) {
         this.dataku = {
            users_id: data.users_id,
            password: '',
            confirmPassword: ''
         };
         this.errorMessage = '';
         this.form = {
            ...data,
            users_id: data.users_id,
            id: data.id
         };
         this.lihatData = {
            nama_lengkap: data.nama_lengkap || '',
            nik: data.nik || '',
            tanggal_lahir: data.tanggal_lahir || '',
            jenis_kelamin: data.jenis_kelamin || '',
            email: data.email || '',
            no_hp: data.no_hp || '',
            alamat: data.alamat || '',
            nama_kabupaten: data.nama_kabupaten || '',
            nama_kecamatan: data.nama_kecamatan || '',
            nama_des_kel: data.nama_des_kel || '',
            foto_profil: data.foto_profil || '',
            username: data.username || '',
            users_id: data.users_id || '',
            id: data.id || '',
         };
      },

      resetPasswordForm() {
         this.dataku.password = '';
         this.dataku.confirmPassword = '';
         this.dataku.users_id = null;
         this.isPwd = true;
         this.isPwd2 = true;
         this.btn_password = false;
         this.mdl_password = false;
      },

      resetHapusForm() {
         this.form.id = null;
         this.form.users_id = null;
         this.btn_hapus = false;
         this.mdl_hapus = false;
      },

      indexing(idx) {
         return ((this.page_first - 1) * this.page_limit) + idx;
      },

      normalizeDate(dateStr) {
         if (!dateStr || dateStr === '') return '';
         if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) return dateStr;
         if (dateStr.includes('T')) return dateStr.split('T')[0];
         return '';
      },

      cari_data() {
         this.page_first = 1;
         this.getView();
      },

      handleImageError(event) {
         event.target.src = 'path/to/placeholder-image.jpg';  // Ganti dengan URL placeholder default, atau kosongkan src
         // Atau: event.target.style.display = 'none'; untuk sembunyikan img rusak
      },
   },
   mounted() {
      this.getView();
      this.loadKabupaten();
   }
}
